<div class="chatUserPropmpt_container">
    <div class="chatUserPropmpt_userEntryContainer" [ngClass]="{'is-mobile-view': isMobileView}">
        <button *ngIf="presentForceUseCases" mat-mini-fab class="chatUserPrompt_userForceUseCasesPresentationBtn" (click)="forceUseCasesPresentation()"><mat-icon>person_raised_hand</mat-icon></button>
            <textarea #userPromptArea matInput 
                class="chatUserPrompt_userEntryTextArea" 
                [placeholder]="'chatView.userEntryPlaceHolder' | gender | translate" 
                [(ngModel)]="userText"
                (keydown.enter)="handleEnter($event)">
            </textarea>
        <button mat-icon-button color="primary" class="chatUserPrompt_submitButton" (click)="submitUserEntry()" [disabled]="userText==''" >
            <img src="assets/common/send_btn_icon.svg" alt="sendIcon" class="chatUserPrompt_submitIcon" />
        </button>    
    </div>
</div>
